import { render, staticRenderFns } from "./TnkcHouseSwabTest.vue?vue&type=template&id=79563516&scoped=true"
import script from "./TnkcHouseSwabTest.vue?vue&type=script&lang=js"
export * from "./TnkcHouseSwabTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79563516",
  null
  
)

export default component.exports